import * as React from "react";
import {FormattedMessage} from "react-intl";
import {ColumnsDescription, ColumnWidth} from "../common/ui/table/ControlRoomColumns";
import {AOINotificationArea} from "./model";

export const AOIColumns: ColumnsDescription<AOINotificationArea> = {
    name: {
        header: <FormattedMessage id="studio.notifications.aoi-columns.name" defaultMessage="Name"/>,
        cellContent(notification) {
            return <span className="link" data-is-main-link={true}>{notification.name}</span>;
        },
        cellTooltip: (notification) => notification.name,
        columnWidth: ColumnWidth.flex(1),
    },
    events: {
        header: null,
        cellContent() {
            return <FormattedMessage id="studio.notifications.aoi-columns.events" defaultMessage="Browse events"
                                     children={msg =>
                                         <span className="link" data-is-browse-events-link={true}>{msg}</span>}/>;
        },
        cellTooltip: () => "Browse events",
        columnWidth: ColumnWidth.pixels(120),
    },
};